<template>
	<svg width="310" height="310" viewBox="0 0 340 340" aria-hidden="true">
		<defs>
			<linearGradient id="lps-scanGlow" x1="0" y1="0" x2="0" y2="1">
				<stop offset="0" stop-color="currentColor" stop-opacity="0" />
				<stop offset="0.5" stop-color="currentColor" stop-opacity="0.25" />
				<stop offset="1" stop-color="currentColor" stop-opacity="0" />
			</linearGradient>
			<clipPath id="lps-qrClip">
				<rect x="28" y="28" width="284" height="284" rx="22" />
			</clipPath>
		</defs>

		<path
			class="animated_qr_corners"
			d="M8 52 V22 Q8 8 22 8 H52 M288 8 H318 Q332 8 332 22 V52 M332 288 V318 Q332 332 318 332 H288 M52 332 H22 Q8 332 8 318 V288"
			fill="none"
			stroke="currentColor"
			stroke-width="7"
			stroke-linecap="round"
		/>

		<rect x="28" y="28" width="284" height="284" rx="22" fill="#FFFFFF" stroke="#E8EBEF" stroke-width="1.5" />

		<g transform="translate(45 45)">
			<path
				d="M150 0h10v10h-10zM160 0h10v10h-10zM80 10h10v10h-10zM90 10h10v10h-10zM130 10h10v10h-10zM140 10h10v10h-10zM150 10h10v10h-10zM110 20h10v10h-10zM130 20h10v10h-10zM80 30h10v10h-10zM90 30h10v10h-10zM110 30h10v10h-10zM120 30h10v10h-10zM150 30h10v10h-10zM80 40h10v10h-10zM150 40h10v10h-10zM80 50h10v10h-10zM100 50h10v10h-10zM120 50h10v10h-10zM130 50h10v10h-10zM150 50h10v10h-10zM160 50h10v10h-10zM80 60h10v10h-10zM100 60h10v10h-10zM120 60h10v10h-10zM140 60h10v10h-10zM160 60h10v10h-10zM90 70h10v10h-10zM100 70h10v10h-10zM0 80h10v10h-10zM10 80h10v10h-10zM20 80h10v10h-10zM50 80h10v10h-10zM60 80h10v10h-10zM80 80h10v10h-10zM90 80h10v10h-10zM100 80h10v10h-10zM110 80h10v10h-10zM120 80h10v10h-10zM130 80h10v10h-10zM160 80h10v10h-10zM170 80h10v10h-10zM180 80h10v10h-10zM200 80h10v10h-10zM210 80h10v10h-10zM230 80h10v10h-10zM0 90h10v10h-10zM70 90h10v10h-10zM80 90h10v10h-10zM90 90h10v10h-10zM100 90h10v10h-10zM120 90h10v10h-10zM160 90h10v10h-10zM200 90h10v10h-10zM210 90h10v10h-10zM30 100h10v10h-10zM40 100h10v10h-10zM60 100h10v10h-10zM70 100h10v10h-10zM90 100h10v10h-10zM120 100h10v10h-10zM130 100h10v10h-10zM170 100h10v10h-10zM0 110h10v10h-10zM10 110h10v10h-10zM20 110h10v10h-10zM30 110h10v10h-10zM70 110h10v10h-10zM90 110h10v10h-10zM120 110h10v10h-10zM130 110h10v10h-10zM170 110h10v10h-10zM200 110h10v10h-10zM210 110h10v10h-10zM220 110h10v10h-10zM230 110h10v10h-10zM0 120h10v10h-10zM20 120h10v10h-10zM30 120h10v10h-10zM40 120h10v10h-10zM50 120h10v10h-10zM60 120h10v10h-10zM70 120h10v10h-10zM90 120h10v10h-10zM110 120h10v10h-10zM130 120h10v10h-10zM150 120h10v10h-10zM160 120h10v10h-10zM180 120h10v10h-10zM220 120h10v10h-10zM230 120h10v10h-10zM20 130h10v10h-10zM30 130h10v10h-10zM40 130h10v10h-10zM130 130h10v10h-10zM140 130h10v10h-10zM150 130h10v10h-10zM160 130h10v10h-10zM230 130h10v10h-10zM10 140h10v10h-10zM20 140h10v10h-10zM30 140h10v10h-10zM40 140h10v10h-10zM50 140h10v10h-10zM60 140h10v10h-10zM80 140h10v10h-10zM90 140h10v10h-10zM110 140h10v10h-10zM120 140h10v10h-10zM130 140h10v10h-10zM140 140h10v10h-10zM170 140h10v10h-10zM180 140h10v10h-10zM200 140h10v10h-10zM240 140h10v10h-10zM0 150h10v10h-10zM10 150h10v10h-10zM20 150h10v10h-10zM30 150h10v10h-10zM50 150h10v10h-10zM90 150h10v10h-10zM100 150h10v10h-10zM110 150h10v10h-10zM120 150h10v10h-10zM140 150h10v10h-10zM190 150h10v10h-10zM210 150h10v10h-10zM0 160h10v10h-10zM40 160h10v10h-10zM50 160h10v10h-10zM60 160h10v10h-10zM80 160h10v10h-10zM90 160h10v10h-10zM100 160h10v10h-10zM120 160h10v10h-10zM130 160h10v10h-10zM150 160h10v10h-10zM160 160h10v10h-10zM190 160h10v10h-10zM230 160h10v10h-10zM110 170h10v10h-10zM120 170h10v10h-10zM160 170h10v10h-10zM180 170h10v10h-10zM220 170h10v10h-10zM80 180h10v10h-10zM90 180h10v10h-10zM110 180h10v10h-10zM130 180h10v10h-10zM180 180h10v10h-10zM190 180h10v10h-10zM100 190h10v10h-10zM120 190h10v10h-10zM140 190h10v10h-10zM160 190h10v10h-10zM170 190h10v10h-10zM180 190h10v10h-10zM190 190h10v10h-10zM220 190h10v10h-10zM230 190h10v10h-10zM240 190h10v10h-10zM80 200h10v10h-10zM90 200h10v10h-10zM100 200h10v10h-10zM110 200h10v10h-10zM120 200h10v10h-10zM160 200h10v10h-10zM170 200h10v10h-10zM180 200h10v10h-10zM190 200h10v10h-10zM210 200h10v10h-10zM220 200h10v10h-10zM240 200h10v10h-10zM80 210h10v10h-10zM110 210h10v10h-10zM140 210h10v10h-10zM160 210h10v10h-10zM190 210h10v10h-10zM210 210h10v10h-10zM220 210h10v10h-10zM80 220h10v10h-10zM100 220h10v10h-10zM130 220h10v10h-10zM140 220h10v10h-10zM160 220h10v10h-10zM190 220h10v10h-10zM210 220h10v10h-10zM220 220h10v10h-10zM240 220h10v10h-10zM160 230h10v10h-10zM170 230h10v10h-10zM180 230h10v10h-10zM190 230h10v10h-10zM200 230h10v10h-10zM210 230h10v10h-10zM110 240h10v10h-10zM120 240h10v10h-10zM150 240h10v10h-10zM190 240h10v10h-10zM200 240h10v10h-10zM230 240h10v10h-10z"
				fill="#212934"
			/>
			<g>
				<rect x="0" y="0" width="70" height="70" rx="10" fill="#212934" />
				<rect x="10" y="10" width="50" height="50" rx="6" fill="#fff" />
				<rect x="20" y="20" width="30" height="30" rx="4" fill="#212934" />
			</g>
			<g transform="translate(180 0)">
				<rect x="0" y="0" width="70" height="70" rx="10" fill="#212934" />
				<rect x="10" y="10" width="50" height="50" rx="6" fill="#fff" />
				<rect x="20" y="20" width="30" height="30" rx="4" fill="#212934" />
			</g>
			<g transform="translate(0 180)">
				<rect x="0" y="0" width="70" height="70" rx="10" fill="#212934" />
				<rect x="10" y="10" width="50" height="50" rx="6" fill="#fff" />
				<rect x="20" y="20" width="30" height="30" rx="4" fill="#212934" />
			</g>
		</g>

		<g clip-path="url(#lps-qrClip)">
			<g class="animated_qr_beam">
				<rect x="28" y="-64" width="284" height="80" fill="url(#lps-scanGlow)" />
				<rect x="28" y="-26" width="284" height="4" rx="2" fill="currentColor" />
			</g>
		</g>
	</svg>
</template>

<style lang="scss">
.animated_qr_corners {
  animation: lps-corners-pulse 1.8s ease infinite;
}

.animated_qr_beam {
  animation: lps-scan-beam 3.2s cubic-bezier(0.45, 0, 0.55, 1) infinite;
}

@keyframes lps-corners-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.35;
  }
}

@keyframes lps-scan-beam {
  0%,
  100% {
    transform: translateY(60px);
  }
  50% {
    transform: translateY(330px);
  }
}
</style>
